import { NavDropdown } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { formatText } from "util/helper";
import MobileChildMenuItem from "./ChildMenuItemMobile";
import MobileGrandChildrenMenu from "./GrandChildrenMenuMobile";
import classes from "./ParentNavItemListMobile.module.css";
import "../ParentNavItemListMobile-helper.css";

const ParentNavItemListMobile = ({
  item,
  showModalsHandler,
  modalContents,
  setNavOpen,
}) => {
  return (
    <div className={`parent-mobile-menu ${classes["parent-mobile-menu"]}`}>
      <NavDropdown
        title={<FormattedMessage id={formatText(item.title)} />}
        id="nav-dropdown-1"
      >
        {item.children.map(childItem => {
          let hasGrandChildren = childItem.classes.find(
            item => item === "hasGrand"
          );
          if (childItem.menu_item_parent !== 0 && hasGrandChildren) {
            return (
              <MobileGrandChildrenMenu
                key={childItem.ID}
                childItem={childItem}
                showModalsHandler={showModalsHandler}
                modalContents={modalContents}
                setNavOpen={setNavOpen}
              />
            );
          } else {
            return (
              <MobileChildMenuItem
                key={childItem.ID}
                childItem={childItem}
                setNavOpen={setNavOpen}
              />
            );
          }
        })}
      </NavDropdown>
    </div>
  );
};

export default ParentNavItemListMobile;
